import React from "react";
// Import Swiper React components
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";

import "./style/styles.css";

// import required modules

/*------------------IMPORT IMG--------------- */

import f1_min from "../assets/image/auto/f1-min.jpg";
import f1_w from "../assets/image/auto/f1.webp";
//
import f2_min from "../assets/image/auto/f2-min.jpg";
import f2_w from "../assets/image/auto/f2.webp";
//
import f3_min from "../assets/image/auto/f3-min.jpg";
import f3_w from "../assets/image/auto/f3.webp";
//
import f4_min from "../assets/image/auto/f4-min.jpg";
import f4_w from "../assets/image/auto/f4.webp";
//
import f5_min from "../assets/image/auto/f5-min.jpg";
import f5_w from "../assets/image/auto/f5.webp";
//
import f6_min from "../assets/image/auto/f6-min.jpg";
import f6_w from "../assets/image/auto/f6.webp";
//
import f7_min from "../assets/image/auto/f7-min.jpg";
import f7_w from "../assets/image/auto/f7.webp";
//
import f8_min from "../assets/image/auto/f8-min.jpg";
import f8_w from "../assets/image/auto/f8.webp";
//
import f9_min from "../assets/image/auto/f9-min.jpg";
import f9_w from "../assets/image/auto/f9.webp";
//
import f10_min from "../assets/image/auto/f10-min.jpg";
import f10_w from "../assets/image/auto/f10.webp";

export default function SwiperEffect() {
  return (
    <>
      <Swiper
        pagination={{
          dynamicBullets: true,
        }}
        modules={[Pagination]}
        className="mySwiper"
      >

        {/* -----------F1---------- */}
        <SwiperSlide>
          {" "}
          <picture>
            <source srcSet={f1_w} type="image/webp" />
            <source srcSet={f1_min} type="image/jpg" />
            <img src={f1_min} alt="swiper_img" srcSet="" />
          </picture>
        </SwiperSlide>
        {/* -----------F1---------- */}
        <SwiperSlide>
          {" "}
          <picture>
            <source srcSet={f2_w} type="image/webp" />
            <source srcSet={f2_min} type="image/jpg" />
            <img src={f2_min} alt="swiper_img" srcSet="" />
          </picture>
        </SwiperSlide>
        {/* -----------F1---------- */}
        <SwiperSlide>
          {" "}
          <picture>
            <source srcSet={f3_w} type="image/webp" />
            <source srcSet={f3_min} type="image/jpg" />
            <img src={f1_min} alt="swiper_img" srcSet="" />
          </picture>
        </SwiperSlide>
        {/* -----------F1---------- */}
        <SwiperSlide>
          {" "}
          <picture>
            <source srcSet={f4_w} type="image/webp" />
            <source srcSet={f4_min} type="image/jpg" />
            <img src={f4_min} alt="swiper_img" srcSet="" />
          </picture>
        </SwiperSlide>
        {/* -----------F1---------- */}
        <SwiperSlide>
          {" "}
          <picture>
            <source srcSet={f5_w} type="image/webp" />
            <source srcSet={f5_min} type="image/jpg" />
            <img src={f5_min} alt="swiper_img" srcSet="" />
          </picture>
        </SwiperSlide>
        {/* -----------F1---------- */}
        <SwiperSlide>
          {" "}
          <picture>
            <source srcSet={f6_w} type="image/webp" />
            <source srcSet={f6_min} type="image/jpg" />
            <img src={f6_min} alt="swiper_img" srcSet="" />
          </picture>
        </SwiperSlide>
        {/* -----------F1---------- */}
        <SwiperSlide>
          {" "}
          <picture>
            <source srcSet={f7_w} type="image/webp" />
            <source srcSet={f7_min} type="image/jpg" />
            <img src={f7_min} alt="swiper_img" srcSet="" />
          </picture>
        </SwiperSlide>
        {/* -----------F1---------- */}
        <SwiperSlide>
          {" "}
          <picture>
            <source srcSet={f8_w} type="image/webp" />
            <source srcSet={f8_min} type="image/jpg" />
            <img src={f8_min} alt="swiper_img" srcSet="" />
          </picture>
        </SwiperSlide>
        {/* -----------F1---------- */}
        <SwiperSlide>
          {" "}
          <picture>
            <source srcSet={f9_w} type="image/webp" />
            <source srcSet={f9_min} type="image/jpg" />
            <img src={f9_min} alt="swiper_img" srcSet="" />
          </picture>
        </SwiperSlide>
        {/* -----------F1---------- */}
        <SwiperSlide>
          {" "}
          <picture>
            <source srcSet={f10_w} type="image/webp" />
            <source srcSet={f10_min} type="image/jpg" />
            <img src={f10_min} alt="swiper_img" srcSet="" />
          </picture>
        </SwiperSlide>
      </Swiper>
    </>
  );
}
